import React from 'react';
import { withStyles } from '@material-ui/core';
import { Box, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { VButton, VTypography } from '@venti-components';
import styles from './SuccessPurchaseContent.styles';
import { ReactComponent as SuccessImage } from '../../../../assets/images/successMailValidation.svg';

const SuccessPurchaseContent = ({ classes, order }) => {
  const theme = useTheme();
  const { id: orderId, mail, Payments: payments, Qrs: qrs } = order;
  const ticketsPayment = payments.find(({ type }) => type === 'tickets');
  const ticketsPriceInCents = ticketsPayment.finalPriceInCents || 0;

  const tickets = qrs.reduce((tickets, { TicketType }) => {
    const { id, name } = TicketType;

    if (!tickets[id]) {
      tickets[id] = {
        name,
        quantity: 1,
      };
    } else {
      tickets[id].quantity++;
    }
    return tickets;
  }, {});

  return (
    <Stack className={classes.successContainer}>
      <Stack className={classes.successContent}>
        <Stack alignItems="center" justifyContent="center" mb={4}>
          <SuccessImage />
        </Stack>
        <Stack gap={3}>
          <VTypography align="center" variant="h2" className="mailValidationPageTitle">
            ¡Ya estás adentro!
          </VTypography>
          <VTypography variant="body1" color={theme.palette.text.secondary} align="center">
            Tus tickets ya están en tu cuenta. Te mandamos el resumen a{' '}
            <span className={classes.orderMail}>{mail}</span>. Tu número de orden es{' '}
            <span className={classes.orderId}>{orderId}</span>.
          </VTypography>
        </Stack>
      </Stack>
      <Stack className={classes.buttonsContainer}>
        <VButton
          fullWidth="always"
          href="https://app.venti.live/"
          label="Ver mis tickets en la app"
          size="large"
        />
        <VButton
          fullWidth="always"
          href="/eventos"
          variant="outlined"
          label="Explorar más eventos"
          size="large"
        />
      </Stack>

      <Box id="pixelInformation" display="none">
        <Box className="pixelOrderPrice">{ticketsPriceInCents / 100}</Box>
        {Object.values(tickets).map(({ name, quantity }) => (
          <Box className="pixelOrderTickets" key={name}>
            <span className="ticketName">{name}</span>
            <span className="ticketQuantity">{quantity}</span>
          </Box>
        ))}
      </Box>
    </Stack>
  );
};

export default withStyles(styles)(SuccessPurchaseContent);
